import { createContext } from 'react';
var MenuContext = /*#__PURE__*/createContext({
  inlineCollapsed: false
});
export default MenuContext;